import styles from '../styles/EarnCard.module.css'
export const ApyCard = () => {
    return(
    <div className={styles.container}>
        <div className={styles.card}>
            <div className={styles.cnt}>
                <h1 className={styles.items}>Up to 8%</h1>
                <h2 className={styles.items}>Daily Return</h2>
                <h1 className={styles.items}>APR</h1>
                <h2 className={styles.items}>2,945%</h2>
                <h1 className={styles.items}>Referral Bonus</h1>
                <h2 className={styles.items}>L1 10%, L2 2%, L3 1%</h2>
            </div>
            
        </div>
    </div>
    );
} 